"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Sentry = tslib_1.__importStar(require("@sentry/browser"));
const react_ga_1 = tslib_1.__importDefault(require("react-ga"));
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
const hooks_1 = require("./");
const debug_1 = require("../debug");
const react_1 = require("react");
const react_use_1 = require("react-use");
const getData = (context) => {
    var _a, _b, _c, _d;
    const environment = context.appSettings && context.appSettings.environment;
    const siteUrl = context.appSettings && context.appSettings.siteUrl;
    const appVersion = context.appSettings && context.appSettings.version;
    const isLoggedIn = !!context.currentUser;
    const isAppAdmin = !!(context.currentUser && context.currentUser.isAppAdmin);
    const adminRole = context.adminRole;
    const isWorkspaceAdmin = !!(context.currentWorkspaceMembership &&
        context.currentWorkspaceMembership.isWorkspaceAdmin);
    const isWorkspaceAnalyticsEnabled = !!((_a = context.currentWorkspace) === null || _a === void 0 ? void 0 : _a.isWorkspaceAnalyticsEnabled);
    const isUserAnalyticsEnabled = !!((_b = context.currentWorkspace) === null || _b === void 0 ? void 0 : _b.isUserAnalyticsEnabled);
    const workspaceId = (_c = context.currentWorkspace) === null || _c === void 0 ? void 0 : _c.id;
    const userId = (_d = context.currentUser) === null || _d === void 0 ? void 0 : _d.id;
    // Do not log because user is logged in, and workspace analytics aren't enabled
    // (App admins are exempted and will be logged either way)
    if (adminRole !== 'app' && isLoggedIn && !isWorkspaceAnalyticsEnabled) {
        return false;
    }
    const data = {
        adminRole,
        appId: 'osmosys',
        appName: 'osmosys',
        appVersion: (appVersion || 'unknown').substr(0, 80),
        environment,
        isAppAdmin,
        isLoggedIn,
        isUserAnalyticsEnabled,
        isWorkspaceAdmin,
        isWorkspaceAnalyticsEnabled,
        siteUrl,
        workspaceId,
    };
    if (isLoggedIn && (adminRole === 'app' || isUserAnalyticsEnabled)) {
        data.userId = userId;
    }
    return data;
};
exports.useAnalytics = () => {
    var _a, _b, _c, _d;
    const context = hooks_1.useOsmosysContext();
    const { location: { pathname }, } = use_react_router_1.default();
    const [inited, toggleInited] = react_use_1.useToggle(false);
    react_1.useEffect(() => {
        if (!inited) {
            console.log('Initializing ReactGA...');
            react_ga_1.default.initialize('UA-143873706-1', {
                debug: debug_1.OSMOSYS_DEBUG_ANALYTICS,
            });
            toggleInited(true);
        }
    }, [inited]);
    react_1.useEffect(() => {
        if (inited) {
            const data = getData(context);
            if (data) {
                console.log('Setting ReactGA pageview...');
                react_ga_1.default.pageview(pathname);
                // Log it to Sentry
                Sentry.addBreadcrumb({
                    category: 'pageview',
                    data,
                    level: Sentry.Severity.Info,
                    message: pathname,
                });
            }
        }
    }, [inited, pathname + ((_b = (_a = context) === null || _a === void 0 ? void 0 : _a.currentUser) === null || _b === void 0 ? void 0 : _b.id)]);
    react_1.useEffect(() => {
        if (inited) {
            const data = getData(context);
            if (data) {
                console.log('Setting ReactGA properties...');
                react_ga_1.default.set(data);
            }
        }
    }, [inited, (_d = (_c = context) === null || _c === void 0 ? void 0 : _c.currentUser) === null || _d === void 0 ? void 0 : _d.id]);
};
//# sourceMappingURL=useAnalytics.js.map